const SAP_BRIDGE_PROVIDERS = ['sap', 'bridge'];

function getActiveProvider(store: { state?: { AuthModule?: { active_provider?: string } } }): string {
    return String(store?.state?.AuthModule?.active_provider || '')
        .toLowerCase()
        .trim();
}

function getEnvProvider(): string {
    return (process.env.VUE_APP_ERP_PROVIDER || '').toLowerCase().trim();
}

/**
 * Tenant-level Erply vs SAP bridge (menu link, default integration).
 * Does not depend on the current page route.
 */
export function shouldUseErplyIntegration(store: { state?: { AuthModule?: { active_provider?: string } } }): boolean {
    const envProvider = getEnvProvider();
    if (envProvider === 'erply') {
        return true;
    }
    if (SAP_BRIDGE_PROVIDERS.includes(envProvider)) {
        return false;
    }

    const provider = getActiveProvider(store);
    if (provider === 'erply' || provider.includes('erply')) {
        return true;
    }
    if (SAP_BRIDGE_PROVIDERS.includes(provider)) {
        return false;
    }

    // Joogi / CoffeeCup / Dobby: default to Erply when not explicitly Sap/Bridge
    return true;
}

/**
 * True when Erply API endpoints should be used (e.g. /erply/get-products).
 */
export function isErplyProvider(store: { state?: { AuthModule?: { active_provider?: string } } }, routePath?: string): boolean {
    if (shouldUseErplyIntegration(store)) {
        return true;
    }
    if (routePath?.startsWith('/erply') || routePath?.startsWith('/sap')) {
        return !SAP_BRIDGE_PROVIDERS.includes(getActiveProvider(store));
    }
    return false;
}

export function getErpRoute(store: { state?: { AuthModule?: { active_provider?: string } } }): string {
    return shouldUseErplyIntegration(store) ? '/erply' : '/sap';
}

export default isErplyProvider;
